import moment from 'moment'
import React from 'react'
import {
  useGames,
  useContent
} from 'data/hooks'
import { useNavigate } from 'react-router-dom'

import bellwhite from 'assets/images/zurich/bell-white.svg'

const Game = props => {

  const navigate = useNavigate()

  const goGame = () => {

    const now = moment()
    const startdate = moment(props.game.startDate)

    if (startdate.isAfter(now)) {

      props.showmessage &&
        props.showmessage(`El juego ${props.game.title} estará disponible próximamente`)

    } else {

      navigate(`/games/${props.game.gameId}`)
    }
  }

  const {
    title,
    description,
    image
  } = useContent(props.game.wpId)


  return <div
    className={`game ${props.game.tags.split(',').join(' ')}`}
    onClick={goGame}
  >
    <div className="image">
      <img src={image} />
    </div>
    <div className="title-description">
      <div className="title">
        {props.game.title}
      </div>
      <div className="description">
        {description}
      </div>
      {
        false &&
        <div className="bell">
          <img src={bellwhite} />
          <div className="number">
            1
          </div>
        </div>
      }
    </div>
  </div>
}

export const Games = props => {

  const { games } = useGames()

  const orderedgames = games ?
    props.maptable ?
      Object.values(games)
        .map(g => ({ ...g, order: props.maptable[g.game.gameId] }))
        .sort((a, b) => a.order - b.order)
      :
      Object.values(games)
    :
    []

  return <div className="games">
    {
      games &&
      orderedgames
        .map(
          game => <Game {...game} {...props} />
        )
    }
  </div>
}